import React from "react";
import { twMerge } from "tailwind-merge";
import CardHeaderTitle from "./title";
import CardHeaderIcon from "./icon";
import { Element } from "src/components/base";

interface IProps {
    className?: string;
    children?: React.ReactNode;
}

export function CardHeader({ className = "", children }: IProps) {
    return (
        <Element
            className={twMerge(
                "bm-card-header",
                className
            )}
        >
            {children}
        </Element>
    );
}
CardHeader.Title = CardHeaderTitle;
CardHeader.Icon = CardHeaderIcon;

export default CardHeader;
